import { LOADED, LOADEDING } from "../actions/types";


const initState = {
    loading: null,
}

export default (state = initState , action) => {
    switch (action.type) {
        case LOADEDING:
            return{
                ...state, 
                loading: true,
            };
        case LOADED:
            return{
                ...state, 
                loading: false,
            };
    
        default:
            return state;
    }
}